(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["igs-sticky-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('igs-sticky-buy')) {
    customElements.define('igs-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.source = this.form?.closest('[data-section-type="product"]');
        if (!this.source) return;
        this.action = this.querySelector('[data-sticky-add]');
        this.actions = this.querySelector('.igs-sticky-buy__actions');
        this.price = this.querySelector('[data-sticky-price]');
        this.error = this.querySelector('[data-sticky-error]');
        this.events = new AbortController();
        this.spacer = document.createElement('div');
        this.spacer.setAttribute('aria-hidden', 'true');
        document.body.append(this.spacer);
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
        };
        const options = { signal: this.events.signal };
        window.addEventListener('scroll', this.schedule, { ...options, passive: true });
        window.addEventListener('resize', this.schedule, options);
        this.source.addEventListener('input', this.schedule, options);
        this.source.addEventListener('change', this.schedule, options);
        this.action.addEventListener('click', () => {
          const form = document.getElementById(this.dataset.formId);
          const original = form?.querySelector('[data-add-to-cart]');
          if (!original || original.disabled || original.classList.contains('loading')) return;
          if (!form.reportValidity()) {
            form.querySelector(':invalid')?.scrollIntoView({ block: 'center', behavior: 'smooth' });
            return;
          }
          this.pending = true;
          this.error.textContent = '';
          this.error.hidden = true;
          original.click();
          this.sync();
        }, options);
        this.productObserver = new MutationObserver(this.schedule);
        this.productObserver.observe(this.source, {
          subtree: true, childList: true, characterData: true, attributes: true,
          attributeFilter: ['disabled', 'class', 'value']
        });
        this.overlayObserver = new MutationObserver(this.schedule);
        this.overlayObserver.observe(document.documentElement, {
          attributes: true, attributeFilter: ['data-scroll-locked']
        });
        this.schedule();
      }

      sync() {
        const form = document.getElementById(this.dataset.formId);
        const original = form?.querySelector('[data-add-to-cart]');
        if (!original) { this.hidden = true; this.spacer.style.height = '0px'; return; }
        const loading = original.classList.contains('loading');
        const success = original.classList.contains('has-success');
        this.action.disabled = original.disabled;
        this.action.setAttribute('aria-busy', String(loading));
        this.action.classList.toggle('loading', loading);
        this.action.classList.toggle('has-success', success);
        this.actions.classList.toggle('product__form--buybutton', Boolean(original.closest('.product__form--buybutton')));
        if (this.buttonMarkup !== original.innerHTML) {
          this.buttonMarkup = original.innerHTML;
          this.action.replaceChildren(...Array.from(original.childNodes, node => node.cloneNode(true)));
        }
        this.action.setAttribute('aria-label', original.querySelector('.btn-state-ready')?.textContent.trim() || original.textContent.trim());
        const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
        const price = this.source.querySelector('.product__price')?.textContent.trim();
        if (price) this.price.textContent = `${quantity > 1 ? `${quantity} × ` : ''}${price}`;
        if (success) this.pending = false;
        if (this.pending && !loading && !original.disabled) {
          const error = form.querySelector('[data-add-action-errors]')?.textContent.trim();
          if (error) { this.error.textContent = error; this.error.hidden = false; this.pending = false; }
        }
        const above = original.getBoundingClientRect().bottom <= 0;
        const closing = document.querySelector('[data-bundle-closing-add]')?.getBoundingClientRect();
        const closingVisible = closing && closing.height > 0 && closing.top >= 0 && closing.bottom <= window.innerHeight;
        const overlay = document.documentElement.hasAttribute('data-scroll-locked');
        this.hidden = !above || overlay || closingVisible;
        this.spacer.style.height = `${this.hidden ? 0 : this.getBoundingClientRect().height}px`;
      }

      disconnectedCallback() {
        this.events?.abort();
        this.productObserver?.disconnect();
        this.overlayObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.spacer?.remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
